import React, { useState } from "react";
import Icon from "../ui/icon";
import "../../assets/styles/component/layout/sideNav.css";
import { NavLink } from "react-router-dom";

const SideNav = ({
  active,
  userName,
  emailID,
  campaignOpenInitial,
  accManagerName,
  accManagerEmail
}) => {
  const [campaignOpen, setCampaignOpen] = useState(campaignOpenInitial || false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const toggleCampaigns = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCampaignOpen(!campaignOpen);
    // Reset transition lock after animation completes
    setTimeout(() => setIsTransitioning(false), 300);
  };

  return (
    <aside className={active ? "side-nav active" : "side-nav"}>
      <div className="profile-card">
        <Icon name="UserCircle" />
        <div className="userInfo">
          <span>{userName || "User Name"}</span>
          <span>{emailID || "Email ID"}</span>
        </div>
      </div>

      <div className="options">
        <span className="dividing-text">GENERAL</span>

        <NavLink to="/" className="option">
          <div>
            <Icon name="Home" className="main-icon" />
            <span>Dashboard</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        {/* Campaigns Expandable Section */}
        <div className="campaigns-section">
          <div
            className={`campaigns-header ${campaignOpen ? 'open' : ''}`}
            onClick={toggleCampaigns}
          >
            <div className="header-content">
              <Icon name="ListBullet" className="main-icon" />
              <span>Campaigns</span>
            </div>
            <Icon
              name="ChevronDown"
              className={`campaigns-chevron ${campaignOpen ? 'rotate' : ''}`}
            />
          </div>

          <div className={`campaigns-submenu ${campaignOpen ? 'expanded' : 'collapsed'}`}>
            <NavLink
              to="/campaigns"
              className="submenu-option"
              onClick={(e) => e.stopPropagation()}
            >
              <Icon name="ListBullet" className="submenu-icon" />
              <span>All Campaigns</span>
            </NavLink>

            <NavLink
              to="/approved-campaigns"
              className="submenu-option"
              onClick={(e) => e.stopPropagation()}
            >
              <Icon name="CheckBadge" className="submenu-icon" />
              <span>Approved Campaigns</span>
            </NavLink>
          </div>
        </div>

        <NavLink to="/reports" className="option">
          <div>
            <Icon name="ChartBar" className="main-icon" />
            <span>Reports</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <span className="dividing-text">EARNINGS</span>

        <NavLink to="/cashback-offers" className="option">
          <div>
            <Icon name="BankNotes" className="main-icon" />
            <span>Cashback Offers</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <NavLink to="/wallet" className="option">
          <div>
            <Icon name="Wallet" className="main-icon" />
            <span>Wallet</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <span className="dividing-text">INTEGRATION</span>

        <NavLink to="/global-postback" className="option">
          <div>
            <Icon name="Link" className="main-icon" />
            <span>Postback</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>
        <NavLink to="/test-campaign-link" className="option">
          <div>
            <Icon name="Beaker" className="main-icon" />
            <span>Integration Tester</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <span className="dividing-text">PROFILE</span>

        <NavLink to="/profile" className="option">
          <div>
            <Icon name="UserCircle" className="main-icon" />
            <span>Profile</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>

        <NavLink to="/settings" className="option">
          <div>
            <Icon name="Cog6Tooth" className="main-icon" />
            <span>Settings</span>
          </div>
          <Icon name="ChevronRight" className="side-icon" />
        </NavLink>
      </div>

      <div className="account-manager-card">
        <span className="label">Account Manager</span>

        <div className="manager-info">
          <Icon name="UserCircle" className="manager-icon" />
          <div className="details">
            <span className="name">{accManagerName}</span>
            <span className="email">{accManagerEmail}</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default SideNav;